<template>
  <div class="big">
    <div class="page_title">用户信息列表</div>
    <div style="padding: 20px">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item index="1" style="font-size: 16px">已绑定</el-menu-item>
        <el-menu-item index="2" style="font-size: 16px">未绑定</el-menu-item>
      </el-menu>
      <div class="container mytable">
        <div class="searchbox">
          <div class="item">
            <span>用户昵称</span>
            <el-input
              v-model="nick_name"
              style="width: 120px"
              clearable
            ></el-input>
          </div>

          <div class="item" v-if="is_bind == '1'">
            <span>手机号</span>
            <el-input v-model="phone" style="width: 120px" clearable></el-input>
          </div>

          <div class="item">
            <span>真实姓名</span>
            <el-input
              v-model="real_name"
              style="width: 120px"
              clearable
            ></el-input>
          </div>

          <div class="item">
            <span style="width: 60px">性别</span>
            <el-radio-group
              v-model="sex"
              @change="changeList"
              style="margin: 4px 0 0 0"
            >
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </div>

          <div class="item">
            <span>注册日期</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 225px; margin: 0 10px"
              @change="search"
            ></el-date-picker>
          </div>

          <div class="item">
            <span>平台渠道</span>
            <el-select v-model="platform_channel" clearable @change="search">
              <el-option
                v-for="(item, index) in platformList"
                :key="index"
                :label="item.platform_name"
                :value="item.platform_id"
              ></el-option>
            </el-select>
          </div>

          <div class="item">
            <span style="width: 140px">是否为歧黄学堂用户</span>
            <el-select v-model="is_school" clearable @change="search">
              <el-option label="全部" :value="''"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </div>

          <div class="item">
            <span style="width: 70px">用户来源</span>
            <el-select v-model="user_from" clearable @change="search">
              <el-option
                v-for="(item, index) in userFromOptions"
                :key="index"
                :label="item.name"
                :value="item.user_from"
              ></el-option>
            </el-select>
          </div>

          <!--是否异常 -->
          <div class="item">
            <span>是否异常</span>
            <div class="item-content">
              <el-radio-group v-model="is_abnormal">
                <el-radio :label="-1">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </div>
            <el-button
              type="primary"
              size="medium"
              style="margin-left: 20px"
              @click="search"
              >查询</el-button
            >
          </div>

          <!-- <div class="item">
            <span>收货地区</span>
            <el-select v-model="address"
                       clearable
                       @change="search">
              <el-option v-for="(item,index) in districtData"
                         :key="index"
                         :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </div> -->

          <!-- <div class="item">
            <span>IP所在地</span>
            <el-select v-model="ip"
                       clearable
                       @change="search">
              <el-option v-for="(item,index) in districtData"
                         :key="index"
                         :label="item.label"
                         :value="item.label"></el-option>
            </el-select>
            <el-button plain
                       style="margin-left:10px;background:#ececec"
                       @click="search">查询</el-button>
          </div> -->
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            :data="tableData"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F7f8fa' }"
            :default-expand-all="true"
          >
            <el-table-column label="注册时间" prop="reg_time"></el-table-column>
            <el-table-column label="头像" prop="real_name">
              <template slot-scope="scope">
                <img :src="scope.row.head_img" alt style="width: 60px" />
              </template>
            </el-table-column>
            <el-table-column label="用户昵称">
              <template slot-scope="scope">
                <span>{{ scope.row.nick_name }}</span>
                <span class="cancel_past" v-if="scope.row.cancel_id > 0"
                  >曾经注销</span
                >
              </template>
            </el-table-column>
            <el-table-column label="性别">
              <template slot-scope="scope">
                <span v-if="scope.row.sex == 1">男</span>
                <span v-if="scope.row.sex == 2">女</span>
                <span v-if="scope.row.sex == 0">未知</span>
              </template>
            </el-table-column>
            <el-table-column label="手机号" prop="phone">
              <template slot-scope="scope">
                <span>{{ scope.row.phone }}</span>
                <span class="cancel_past" v-if="scope.row.is_abnormal"
                  >异常</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="真实姓名"
              prop="real_name"
            ></el-table-column>

            <!-- <el-table-column label="身份证号"
                             prop="id_card"></el-table-column> -->
            <!-- <el-table-column label="关联患者数"
                             prop="patient_count"></el-table-column> -->

            <el-table-column
              label="平台渠道"
              prop="platform_channel"
            ></el-table-column>

            <el-table-column label="是否为歧黄学堂用户" prop="platform_channel">
              <template slot-scope="scope">{{
                !scope.row.is_school ? "否" : "是"
              }}</template>
            </el-table-column>
            <!-- <el-table-column label="收货地区"
                             prop="address"></el-table-column> -->
            <!-- <el-table-column label="IP所在地"
                             prop="ip"></el-table-column> -->
            <el-table-column
              label="用户来源"
              prop="user_from_str"
            ></el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="toUserDetail(scope.row.user_id)"
                  :disabled="
                    module_id_array[0] ? !module_id_array.includes('41') : false
                  "
                  >详情</el-button
                >
                <el-button
                  v-if="scope.row.is_cancel == 0"
                  type="text"
                  @click="showCancelDia(scope.row.user_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('884')
                      : false
                  "
                  >注销</el-button
                >
                <!-- <span style="margin-left:10px;color:#669961">
                  测试
                  <el-switch
                    v-model="scope.row.is_test"
                    active-color="#669961"
                    @change="(value)=>{
                    return  setTest(value,scope.row.patient_id)
                  }"
                  ></el-switch>
                </span>-->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 注销弹窗 -->
    <el-dialog
      title="提 示"
      :visible.sync="cancelDia"
      width="700px"
      :close-on-click-modal="false"
    >
      <div class="content">
        <div style="color: #ff7200">
          注意：注销账户前，需核实用户问诊、订单、账户等情况。
        </div>
        <div>
          <div class="box">
            <div class="item">
              <div class="title">● 问诊记录</div>
              <div style="padding-left: 12px">
                <span>待确认</span>
                <span style="margin: 0 30px 0 10px"
                  >{{ statistics_info.to_be_confirmed_consult_count }}条</span
                >
                <span>咨询中</span>
                <span style="margin-left: 10px"
                  >{{ statistics_info.consulting_consult_count }}条</span
                >
              </div>
            </div>
            <div class="item">
              <div class="title">● 预约问诊记录</div>
              <div style="padding-left: 12px">
                <span>待确认</span>
                <span style="margin-left: 10px"
                  >{{ statistics_info.to_be_confirmed_register_count }}条</span
                >
              </div>
            </div>
            <div class="item">
              <div class="title">● 处方订单</div>
              <div style="padding-left: 12px">
                <span>待发货</span>
                <span style="margin: 0 30px 0 10px"
                  >{{
                    statistics_info.to_be_shipped_prescription_count
                  }}条</span
                >
                <span>待收货</span>
                <span style="margin-left: 10px"
                  >{{
                    statistics_info.goods_to_be_received_prescription_count
                  }}条</span
                >
              </div>
            </div>
            <div class="item">
              <div class="title">● 商城订单</div>
              <div style="padding-left: 12px">
                <span>待发货</span>
                <span style="margin: 0 30px 0 10px"
                  >{{ statistics_info.to_be_shipped_order_count }}条</span
                >
                <span>待收货</span>
                <span style="margin: 0 30px 0 10px"
                  >{{
                    statistics_info.goods_to_be_received_order_count
                  }}条</span
                >
              </div>
            </div>
          </div>
          <div class="box">
            <div class="item">
              <div class="title">● 用户积分</div>
              <div class="pricebox">
                <div class="priceitem">
                  <div class="num red">
                    {{ integral_info.integral ? integral_info.integral : 0 }}
                  </div>
                  <div class="gray">当前积分</div>
                </div>
                <div class="priceitem">
                  <div class="num">
                    {{
                      integral_info.use_integral
                        ? integral_info.use_integral
                        : 0
                    }}
                  </div>
                  <div class="gray">已用积分</div>
                </div>
                <div class="priceitem">
                  <div class="num">
                    {{
                      integral_info.expire_integral
                        ? integral_info.expire_integral
                        : 0
                    }}
                  </div>
                  <div class="gray">失效积分</div>
                </div>
              </div>
            </div>
          </div>
          <div class="green">
            是否分销员
            <span>{{ is_staff ? "是" : "否" }}</span>
          </div>
          <div class="box" v-if="is_staff">
            <div class="pricebox">
              <div class="priceitem">
                <div class="num red">{{ commission_info.settled_money }}</div>
                <div class="gray">待结算佣金</div>
              </div>
              <div class="priceitem">
                <div class="num">
                  {{ commission_info.commission_total_price }}
                </div>
                <div class="gray">累计结算佣金</div>
              </div>
              <div class="priceitem">
                <div class="num">{{ commission_info.pay_money }}</div>
                <div class="gray">累计提现</div>
              </div>
              <div class="priceitem">
                <div class="num red">{{ commission_info.settle_money }}</div>
                <div class="gray">余额</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: center; padding-bottom: 20px">
        <span slot="footer" class="dialog-footer">
          <el-button
            plain
            @click="cancelDia = false"
            style="width: 92px"
            size="medium"
            >取消操作
          </el-button>
          <el-button
            type="primary"
            @click="cancelUser"
            style="width: 92px"
            size="medium"
            >确认注销</el-button
          >
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import patient from "../../../api/patient";
import platform from "../../../api/platform";
import common from "@/api/common";
import dayjs from "dayjs";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      activeIndex: "1",
      is_bind: 1,
      real_name: "",
      nick_name: "",
      phone: "",
      sex: 0,
      platform_channel: "",
      // address: '',
      // ip: '',
      is_school: "",
      is_abnormal: -1,
      user_from: "",
      date: [],
      cancelDia: false,
      is_staff: false,
      commission_info: {},
      statistics_info: {},
      integral_info: {},
      user_id: "",
      platformList: [],
      districtProp: {
        value: "value",
        label: "label",
        children: "children",
      },
      // districtData: []
      userFromOptions: [],
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    },
  },
  methods: {
    handleSelect(key) {
      this.nick_name = "";
      this.real_name = "";
      this.currentPage = 1;
      this.pagesize = 10;
      this.is_bind = key;
      this.phone = "";
      this.sex = 0;
      this.platform_channel = "";
      this.is_school = "";
      this.is_abnormal = -1;
      this.user_from = "";
      // this.address = '';
      // this.ip = '';
      this.date = [];
      this.getList();
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        nick_name: this.nick_name,
        phone: this.phone,
        real_name: this.real_name,
        sex: this.sex,
        is_bind: this.is_bind,
        platform_channel: this.platform_channel,
        is_school: this.is_school,
        is_abnormal: this.is_abnormal,
        user_from: this.user_from,
        // address: this.address,
        // ip: this.ip
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.end_time = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/patient/userListNew", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.reg_time = dayjs
                .unix(item.reg_time)
                .format("YYYY-MM-DD HH:mm:ss");
              // item.is_test = item.is_test == 1 ? true : false;
              return item;
            });
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //设置测试账号
    setTest(value, user_id) {
      let text = "";
      let status = "";
      if (value) {
        text = "确定将该账号设置为测试账号？";
        status = 1;
      } else {
        text = "确定取消测试账号？";
        status = 2;
      }

      this.$confirm(text, "提示消息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          patient.setTestUser({ user_id, status }).then((res) => {
            if (res.code == 0) {
              this.$message.success("设置成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.getList();
        });
    },
    //筛选状态
    changeList() {
      this.currentPage = 1;
      this.getList();
    },

    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //用户详情
    toUserDetail(user_id) {
      this.$router.push({
        path: "userdetail",
        query: {
          user_id,
        },
      });
    },
    //注销用户弹窗
    showCancelDia(user_id) {
      this.user_id = user_id;
      this.axios
        .post("platform/patient/getUserCurrentAccountNumber", { user_id })
        .then((res) => {
          this.statistics_info = res.data.statistics_info;
          this.is_staff = res.data.commission_info.commission_total_price
            ? true
            : false;
          this.commission_info = res.data.commission_info;
          this.integral_info = res.data.integral_info
            ? res.data.integral_info
            : {};
          this.cancelDia = true;
        });
    },
    //注销用户
    cancelUser() {
      let user_id = this.user_id;
      this.axios
        .post("platform/patient/saveUserItemOpenId", { user_id })
        .then((res) => {
          this.$message.success("该用户账号已注销");
          this.getList();
          this.cancelDia = false;
        });
    },
    // 平台渠道
    getPlatformList() {
      common.getPlatformList().then((res) => {
        let { code, data } = res;
        if (code === 0) {
          this.platformList = data;
        }
      });
    },
    // 地区 ip
    // async getCityData() {
    //   let { data } = await platform.getProvinceCityDistrict();
    //   this.districtData = data.list.map((item) => {
    //     let obj = {
    //       label: item.name,
    //       value: item.province_id
    //     };
    //     return obj;
    //   });
    // }
    // 获取用户来源列表
    getUserFromList() {
      common.getUserFromList().then((res) => {
        let { code, data } = res;
        if (code === 0) {
          this.userFromOptions = data.list;
        }
      });
    },
  },
  created() {
    this.getUserFromList();
    this.getPlatformList();
    // this.getCityData();
    this.getList();
  },
  activated() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    span {
      display: inline-block;
      width: 100px;
    }
  }
}
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.name_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 120px;
  text-overflow: ellipsis;
}
.content {
  padding: 20px;
  text-align: left;
  .box {
    background: #f5f5f5;
    margin-top: 8px;
    padding: 10px;
  }
  .green {
    color: #669961;
    font-weight: 700;
    margin-top: 20px;
  }
  .title {
    font-weight: 700;
    margin-bottom: 6px;
  }
  .item {
    margin-bottom: 14px;
    &:last-child {
      margin-bottom: 6px;
    }
  }
  .pricebox {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    .priceitem {
      text-align: center;
      padding: 0 30px;
      border-right: solid 1px #d6d6d6;
    }
    .priceitem:before {
      content: "";
    }
    .gray {
      font-size: 12px;
      color: #747981;
      display: inline-block;
      margin-top: 6px;
    }
    .num {
      font-size: 18px;
      font-weight: 600;
    }
    .red {
      color: #f24e33;
    }
  }
}
.cancel_past {
  display: inline-block;
  font-size: 10px;
  color: #ff6c2a;
  border: 1px solid #ff6c2a;
  border-radius: 8px;
  padding: 0 3px;
  margin-left: 10px;
}
</style>
